/* src/app/components/case/uploads/uploads.component.scss */
th[mat-header-cell] {
  font-size: 12px;
}
td[mat-cell] {
  font-size: 14px;
}
table.mat-mdc-table th[mat-header-cell] {
  padding-right: 0px;
  font-size: 12px;
}
.mdc-data-table__cell:first,
.mdc-data-table__header-cell:first,
.mdc-data-table__cell:last,
.mdc-data-table__header-cell:last {
  padding-left: 24px;
}
.mat-mdc-cell,
tr.mat-mdc-row.mdc-data-table__row.cdk-row {
  border-bottom-color: var(--mat-table-row-item-outline-color, rgba(0, 0, 0, 0.12));
  border-bottom-width: var(--mat-table-row-item-outline-width, 1px);
  border-bottom-style: solid;
  letter-spacing: var(--mat-table-row-item-label-text-tracking);
  line-height: inherit;
}
tr:hover {
  background: #f1f1f1;
  transition: 250ms ease-out;
}
.fa-traffic-cone,
.fa-exclamation-circle,
.fa-file-excel {
  color: #303F9F;
}
.fa-check-circle {
  color: #388E3C;
}
.fa-times-circle {
  color: #D32F2F;
}
.mat-toolbar .fa-exclamation-circle {
  color: inherit;
}
.mdc-data-table__cell,
.mdc-data-table__header-cell {
  padding: 0px;
}
:host-context(.dark-theme) tr:hover {
  background: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) .mat-mdc-card:not([class*=mat-elevation-z]) {
  background-color: #2c2c2c;
}
:host-context(.dark-theme) .fa-traffic-cone,
:host-context(.dark-theme) .fa-exclamation-circle,
:host-context(.dark-theme) .fa-file-excel {
  color: #88a3ff;
}
:host-context(.dark-theme) .fa-check-circle {
  color: #3cd041;
}
:host-context(.dark-theme) .fa-times-circle {
  color: #ff5b4f;
}
:host-context(.dark-theme) .mat-toolbar .fa-exclamation-circle {
  color: inherit;
}
td.mat-column-title {
  color: #3f51b7;
}
.mdc-button {
  justify-content: left;
}
table[mat-table] .mdc-button {
  padding: 0 16px;
}
mat-toolbar .mdc-button {
  line-height: normal;
}
.cell-content {
  max-width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=uploads.component.css.map */
